"use strict";
exports.__esModule = true;
var SDKFlags = /** @class */ (function () {
    function SDKFlags() {
    }
    SDKFlags.setFlags = function (newFlags) {
        var typedFlags = newFlags && typeof newFlags === 'object' ? newFlags : {};
        this._flags = typedFlags;
    };
    SDKFlags.on = function (key) {
        return this._flags[key] === true;
    };
    SDKFlags._flags = {};
    return SDKFlags;
}());
exports["default"] = SDKFlags;
